(function HotelEngineHotelDetails($, Adzuki) {
	'use strict';

	// Read before Vue mount; multi-root templates can move data-* attrs to child nodes.
	let initialMountData = {};

	const appConfig = {
		inject: {
			$inject_loggedIn: {
				default: () => Vue.ref(false)
			},
			setLoggedIn: {
				default: () => undefined
			}
		},
		data() {
			return {
				activeTab         : 0,
				baseUri           : Adzuki.base_uri,
				siteUrl           : Adzuki.current_website || window.location.origin,
				coordinates       : {},
				componentToRender : '',
				criteria          : {},
				location          : {},
				roomFilters       : {},
				giataId           : null,
				numRooms          : 1,
				hotel             : null,
				filteredRooms     : {},
				modalTitle        : '',
				modalProps        : {},
				isLoading         : true,
				showModal         : false,
				sideBarLoading    : false,
				sideBarOpen       : false,
				showAlert         : false,
				alertTitle        : null,
				alertMessage      : null,
				alertType         : null,
				redirectAfterAlert: false,
				pendingToast      : null,
				specialtyDetails  : {},
				tabs              : [
					'Available Rooms',
					'Specialty Rates',
					'Map',
					'Amenities',
					'Hotel Information'
				],
				neededScopes: [
					'commissions.view',
					'specialty_rates.read.own'
				],
				availableScopes: {},
				showPayLater   : Boolean(Adzuki.payLaterActive)
		};
		},
		// Define methods for actions
		methods: {
			getHotelDetailsEndpoint() {
				return `${this.baseUri}/HotelEngine/getHotelDetails/`;
			},
			getSearchResultsUrl() {
				if (Adzuki.app === 'Web') {
					return `${this.baseUri}/HotelSearch/searchResults`;
				}

				return `${this.baseUri}/HotelEngine/searchResults`;
			},
			resolveDatasetValue(container, attributeName) {
				if (!container || !attributeName) {
					return '';
				}

				const fromContainer = container.getAttribute(attributeName);

				if (fromContainer) {
					return fromContainer;
				}

				const child = container.querySelector(`[${attributeName}]`);

				return child ? (child.getAttribute(attributeName) || '') : '';
			},
			parseHotelIdFromUrl() {
				const match = window.location.pathname.match(/\/hotelDetails\/([^/]+)/i);

				return match && match[1] ? decodeURIComponent(match[1]) : '';
			},
			resolveHotelId(container) {
				const fromInitialMount = initialMountData.hotelId || '';
				const fromDom          = this.resolveDatasetValue(container, 'data-hotel-id');
				const fromUrl          = this.parseHotelIdFromUrl();
				const fromSession      = sessionStorage.getItem('giataId') || '';

				return fromInitialMount || fromDom || fromUrl || fromSession;
			},
			handleGetHotelsError(message) {
				// Show the error on the search results page instead of a blank details page.
				sessionStorage.setItem('hotelSearchFlash', JSON.stringify({
					type   : 'error',
					title  : 'Unable to load hotel',
					message: message || 'We could not load this hotel. Please try again or select a different hotel.',
				}));

				window.location.href = this.getSearchResultsUrl();
			},
			closeAlert() {
				this.showAlert = false;

				if (this.redirectAfterAlert) {
					this.redirectAfterAlert = false;
					window.location.href = this.getSearchResultsUrl();
				}
			},
			async fetchHotelDetails() {
				console.log('fetchHotelDetails');

				if (!this.giataId) {
					this.handleGetHotelsError('Hotel ID is required.');
					return;
				}

				this.isLoading = true;
				let loaded = false;

				try {
					const criteriaPayload = this.buildSearchCriteriaPayload();

					const formData = new FormData();

					formData.append('hotel_id', this.giataId);
					formData.append('check_in', criteriaPayload.check_in);
					formData.append('check_out', criteriaPayload.check_out);
					formData.append('rooms', JSON.stringify(criteriaPayload.rooms));

					const response = await fetch(this.getHotelDetailsEndpoint(), {
						method: 'POST',
						body  : formData,
					});

					let data;

					try {
						data = await response.json();
					} catch (parseError) {
						console.error('Error parsing hotel details response:', parseError);
						this.handleGetHotelsError('Invalid response from server.');
						return;
					}

					if (!response.ok || data === false || data?.status === 'error') {
						const message = data?.message || `Unable to load hotel details (${response.status}).`;
						console.error('Error while fetching hotel details:', message);
						this.handleGetHotelsError(message);
						return;
					}

					if (data?.status === 'success' && data.data) {
						this.hotel = data.data;
					} else if (data && (data.hotel_id || data.name)) {
						this.hotel = data;
					} else {
						this.handleGetHotelsError('Hotel details are not available.');
						return;
					}

					this.persistSelectedHotel();
					this.filteredRooms = this.hotel.rooms || {};
					loaded            = true;

					console.log('Hotel details fetched:', data);

				} catch (error) {
					console.error('Error:', error);
					this.handleGetHotelsError('An unexpected error occurred while loading hotel details.');

				} finally {
					if (loaded) {
						this.isLoading = false;
					}
				}

			},
			jsonToFormData(jsonString) {
				const json     = JSON.parse(jsonString);
				const formData = new FormData();

				// Iterate through each key-value pair in the JSON object
				Object.keys(json).forEach((key) => {
					if (Array.isArray(json[key])) {
						json[key].forEach((value) => formData.append(`${key}[]`, value));
					} else if (typeof json[key] === "object" && json[key] !== null) {
						Object.keys(json[key]).forEach((subKey) =>
							formData.append(`${key}[${subKey}]`, json[key][subKey])
						);
					} else {
						formData.append(key, json[key]);
					}
				});

				return formData;
			},
			specialtyRateDetails(rate_key) {
				this.sideBarOpen    = true;
				this.sideBarLoading = true;

				const url = `${this.baseUri}/HotelEngine/getSpecialtyRateDetails/`+ encodeURIComponent(rate_key);

				fetch(url)
					.then(response => {
						if (!response.ok) {
							throw new Error(`Error fetching Specialty Rate Details: ${response.statusText}`);
						}
						return response.json();
					})
					.then(data => {
						this.specialtyDetails = data;
						this.sideBarLoading   = false;
					})
					.catch(error => {
						console.error('Error fetching Specialty Rate Details:', error); // Log errors
					});
			},
			selectTab(index) {
				this.activeTab = index; // Update the active tab index
			},
			getRoomImageStyle(room) {
				// Check if the room has an `images` array and that it contains at least one image with `thumbnail_url`
				if (room.images && room.images.length > 0 && room.images[0].url) {
					return `url(${room.images[0].url})`; // Use the first image’s thumbnail URL
				}
				// Fallback to a default image if no image exists
				return `url(${this.baseUri}/images/no-hotel-image-available.png)`;
			},
			openReviewModal() {
				this.modalTitle = '';
				this.modalProps = {
					giataId        : Number(this.giataId),
					hotelName      : this.hotel.name,
					showCloseFooter: true,
				};
				this.componentToRender = Vue.markRaw(Adzuki.VueComponents.HotelEngineReviews);
				this.showModal = true;
			},
			closeModal() {
				this.showModal = false;
			},
			openAlert(type, title, message) {
				this.showAlert    = true;
				this.alertTitle   = title;
				this.alertMessage = message;
				this.alertType    = type;
			},
			openToast(status, message, options) {
				const toastComponent = this.$refs && this.$refs.toast;

				if (!toastComponent || typeof toastComponent.openToast !== 'function') {
					this.pendingToast = {
						status,
						message,
						options: options || {}
					};
					return;
				}

				toastComponent.openToast(status, message, options || {});
			},
			resolveSelectRoomErrorMessage(data, response) {
				let message = data?.message || data?.error || '';

				if (!message && typeof data === 'string' && data.trim()) {
					message = data.trim();
				}

				if (!message && response && !response.ok) {
					message = `Unable to select room (${response.status}).`;
				}

				if (!message) {
					message = 'Unable to select room. Please try again.';
				}

				if (message.toLowerCase().includes('there was an error checking rates:')) {
					message = message.replace(/^there was an error checking rates:\s*/i, '');
				}

				if (message.toLowerCase().includes('rates not found')) {
					return 'This rate is no longer available. Please try different dates or select another room.';
				}

				return message;
			},
			handleSelectRoomError(message) {
				this.openAlert(
					'error',
					'Unable to select room',
					message || 'Unable to select room. Please try again.'
				);
			},
			async selectRoom(rate_select_string) {
				let rateIndex = this.roomDetails?.best_value_rates.findIndex(
					r => r.rate_select_string === rate_select_string
				);

				if (rateIndex === -1) {
					rateIndex = this.roomDetails?.all_rates.findIndex(
						r => r.rate_select_string === rate_select_string
					);
				}

				if (rateIndex === -1) {
					rateIndex = this.roomDetails?.hotel_specialty_rates.findIndex(
						r => r.rate_select_string === rate_select_string
					);
				}

				if (rateIndex === -1) {
					console.error('Rate not found:', rate_select_string);
					this.handleSelectRoomError('The selected rate could not be found. Please refresh and try again.');
					return false;
				}

				try {
					sessionStorage.setItem('rate_select_string', rate_select_string);

					const criteriaRooms = Array.isArray(this.criteria.rooms) ? this.criteria.rooms : [];

					let postCriteria = {
						check_in : this.criteria.check_in || this.criteria.checkIn || '',
						check_out: this.criteria.check_out || this.criteria.checkOut || '',
						rooms    : criteriaRooms.map((room) => {
							let childAges = [];

							if (Array.isArray(room.child_ages)) {
								childAges = room.child_ages.map((age) => String(age));
							} else if (Array.isArray(room.childrenAges)) {
								childAges = room.childrenAges.map((age) => String(age));
							}

							return {
								num_adults  : String(room.num_adults ?? room.numAdults ?? 0),
								num_children: String(room.num_children ?? room.numChildren ?? 0),
								child_ages  : childAges
							};
						})
					};

					const formData = new FormData();

					formData.append('rate_select_string', rate_select_string);
					formData.append('hotel_id', this.giataId);
					formData.append('criteria', JSON.stringify(postCriteria));

					const selectRoomUrl = this.baseUri + '/HotelEngine/selectRoom';

					const response = await fetch(selectRoomUrl, {
						method: 'POST',
						body  : formData,
					});

					let data;

					try {
						data = await response.json();
					} catch (parseError) {
						console.error('Error parsing selectRoom response:', parseError);
						this.handleSelectRoomError('Invalid response from server. Please try again.');
						return false;
					}

					if (!response.ok || data === false || data?.status === 'error' || data?.error) {
						const message = this.resolveSelectRoomErrorMessage(data, response);
						console.error('Error selecting room:', message);
						this.handleSelectRoomError(message);
						return false;
					}

					const room = data?.status === 'success' && data.data ? data.data : data;

					if (!room || typeof room !== 'object') {
						this.handleSelectRoomError('Room details are not available. Please try again.');
						return false;
					}

					sessionStorage.setItem('selectedRoom', JSON.stringify(room));

					if (Adzuki.app === 'Web') {
						window.location.href = this.baseUri + '/HotelSearch/booking/' + this.giataId + '/' + encodeURIComponent(rate_select_string);
					} else {
						window.location.href = this.baseUri + '/HotelEngine/booking/' + this.giataId + '/' + encodeURIComponent(rate_select_string);
					}

					return true;
				} catch (error) {
					console.error('Error selecting room:', error);
					this.handleSelectRoomError('An unexpected error occurred. Please try again.');
					return false;
				}
			},
			handleFilteredRooms(filteredRooms) {
				console.log('handleFilteredRooms', filteredRooms);
				this.filteredRooms = filteredRooms;
			},
			handleRoomFilters(filters) {
				this.roomFilters = filters && typeof filters === 'object' ? filters : {};
				sessionStorage.setItem('roomFilters', JSON.stringify(this.roomFilters));
			},
			getPropertyItems(keys) {
				const property = this.hotel?.property;

				if (!property || typeof property !== 'object') {
					return [];
				}

				return keys.reduce((items, key) => {
					const entry = property[key];

					if (!entry) {
						return items;
					}

					const value = typeof entry === 'object' && entry !== null && 'value' in entry
						? entry.value
						: entry;

					if (!value || (typeof value === 'string' && !value.trim())) {
						return items;
					}

					const label = typeof entry === 'object' && entry !== null && entry.label
						? entry.label
						: key;

					items.push({
						key,
						label,
						value,
					});
					return items;
				}, []);
			},
			async fetchScopes() {
				console.log('fetchScopes');

				try {
					// Structure rooms data
					const formData = new FormData();
					formData.append('scopes', JSON.stringify(this.neededScopes));

					const response = await fetch(this.baseUri + '/HotelSearch/checkScopes/', {
						method: 'POST',
						body  : formData,
					});

					// Handle errors if any
					if (!response.ok) {
						console.error(`Error while fetching scopes: ${response.statusText}`);
					}

					// Parse the response JSON
					const data = await response.json();

					if (data) {
						this.availableScopes = data;
					}
					console.log('Scopes fetched:', data);

				} catch (error) {
					console.error('Error:', error);
				}

			},
			decodeUrlParam(encoded) {
				if (!encoded || typeof encoded !== 'string') {
					return '';
				}

				let base64 = encoded.replace(/-/g, '+').replace(/_/g, '/');
				const pad  = base64.length % 4;

				if (pad > 0) {
					base64 += '='.repeat(4 - pad);
				}

				return base64;
			},
			encodeUrlParam(data) {
				const json = JSON.stringify(data);

				return btoa(json)
					.replace(/\+/g, '-')
					.replace(/\//g, '_')
					.replace(/[=]+$/, '');
			},
			buildSearchCriteriaPayload() {
				const criteriaRooms = Array.isArray(this.criteria.rooms) ? this.criteria.rooms : [];

				const structuredRooms = criteriaRooms.map((room) => {
					let childAges = [];

					if (Array.isArray(room.child_ages)) {
						childAges = room.child_ages;
					} else if (Array.isArray(room.childrenAges)) {
						childAges = room.childrenAges;
					} else if (Array.isArray(room.children_ages)) {
						childAges = room.children_ages;
					}

					return {
						num_adults  : String(room.num_adults ?? room.numAdults ?? 1),
						num_children: String(room.num_children ?? room.numChildren ?? 0),
						child_ages  : childAges.map((age) => String(age))
					};
				});

				return {
					check_in : this.criteria.check_in || this.criteria.checkIn || '',
					check_out: this.criteria.check_out || this.criteria.checkOut || '',
					rooms    : structuredRooms
				};
			},
			buildRoomFiltersPayload() {
				return this.roomFilters && typeof this.roomFilters === 'object'
					? this.roomFilters
					: {};
			},
			normalizeLocationPayload(location, defaultRadius = 20) {
				if (!location || typeof location !== 'object') {
					return null;
				}

				const lat = location.lat ?? location.latitude;
				const lng = location.lng ?? location.longitude;

				if (lat === undefined || lat === null || lng === undefined || lng === null) {
					return null;
				}

				const radiusValue = Number(location.radius ?? defaultRadius);
				const normalized  = {
					lat   : lat,
					lng   : lng,
					radius: Number.isFinite(radiusValue) && radiusValue > 0 ? radiusValue : defaultRadius,
				};

				if (location.place_id) {
					normalized.place_id = location.place_id;
				}

				return normalized;
			},
			buildSearchLocationPayload() {
				const fromComponent = this.normalizeLocationPayload(this.location);

				if (fromComponent) {
					return fromComponent;
				}

				const fromCoordinates = this.normalizeLocationPayload(this.coordinates);

				if (fromCoordinates) {
					return fromCoordinates;
				}

				try {
					const storedLocation = sessionStorage.getItem('searchLocation');

					if (storedLocation) {
						return this.normalizeLocationPayload(JSON.parse(storedLocation));
					}
				} catch (e) {
					// ignore invalid session data
				}

				return null;
			},
			syncCoordinatesFromLocation() {
				const location = this.normalizeLocationPayload(this.location);

				if (!location) {
					return;
				}

				this.coordinates = {
					...this.coordinates,
					lat   : location.lat,
					lng   : location.lng,
					radius: location.radius,
				};

				if (location.place_id) {
					this.coordinates.place_id = location.place_id;
				}
			},
			buildShareUrl() {
				const criteria    = this.buildSearchCriteriaPayload();
				const location    = this.buildSearchLocationPayload();
				const roomFilters = this.buildRoomFiltersPayload();

				if (!this.giataId || !criteria.check_in || !criteria.check_out || !location?.lat || !location?.lng) {
					return '';
				}

				const franchiseUrl = (this.siteUrl || window.location.origin).replace(/\/$/, '');

				return `${franchiseUrl}${this.baseUri}/HotelSearch/hotelDetails/${this.giataId}/${this.encodeUrlParam(criteria)}/${this.encodeUrlParam(location)}/${this.encodeUrlParam(roomFilters)}`;
			},
			async shareSearch() {
				const shareUrl = this.buildShareUrl();

				if (!shareUrl) {
					this.openAlert('warning', 'Unable to share', 'Search details are incomplete. Please run a search first.');
					return;
				}

				try {
					if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
						await navigator.clipboard.writeText(shareUrl);
					} else {
						const textarea = document.createElement('textarea');
						textarea.value = shareUrl;
						textarea.setAttribute('readonly', '');
						textarea.style.position = 'absolute';
						textarea.style.left = '-9999px';
						document.body.appendChild(textarea);
						textarea.select();
						document.execCommand('copy');
						document.body.removeChild(textarea);
					}

					this.openAlert(
						'success',
						'Link copied',
						'The share link has been copied to your clipboard.'
					);
				} catch (error) {
					console.error('Unable to copy share link:', error);
					this.openAlert('info', 'Share this hotel', shareUrl);
				}
			},
			persistSelectedHotel() {
				if (!this.hotel || typeof this.hotel !== 'object') {
					return;
				}

				sessionStorage.setItem('selectedHotel', JSON.stringify(this.hotel));

				const hotelId = this.hotel.hotel_id || this.giataId;

				if (hotelId) {
					sessionStorage.setItem('giataId', hotelId);
				}
			},
			persistSearchToSession() {
				const criteria = this.buildSearchCriteriaPayload();
				const location = this.buildSearchLocationPayload();

				if (!criteria.check_in || !criteria.check_out) {
					return;
				}

				// Keep search results working when arriving from a shared hotel-details link.
				sessionStorage.setItem('searchCriteria', JSON.stringify(criteria));

				if (location) {
					sessionStorage.setItem('searchLocation', JSON.stringify(location));
					sessionStorage.setItem('coordinates', JSON.stringify({
						lat   : location.lat,
						lng   : location.lng,
						radius: location.radius,
						...(location.place_id ? { place_id: location.place_id } : {}),
					}));
				}

				if (this.giataId) {
					sessionStorage.setItem('giataId', String(this.giataId));
				}

				sessionStorage.setItem('roomFilters', JSON.stringify(this.buildRoomFiltersPayload()));

				const storedFormData = sessionStorage.getItem('formData');

				if (!storedFormData && criteria.rooms.length) {
					let locationSearch = '';

					try {
						const storedLocationSearch = sessionStorage.getItem('locationSearch');

						if (storedLocationSearch) {
							locationSearch = JSON.parse(storedLocationSearch);
						}
					} catch (e) {
						locationSearch = '';
					}

					const formData = {
						locationSearch: locationSearch,
						locationRadius: location?.radius || 20,
						checkIn       : criteria.check_in,
						checkOut      : criteria.check_out,
						numRooms      : criteria.rooms.length || 1,
						rooms         : criteria.rooms.map((room, index) => ({
							roomNumber  : index + 1,
							numAdults   : parseInt(room.num_adults, 10) || 2,
							numChildren : parseInt(room.num_children, 10) || 0,
							childrenAges: Array.isArray(room.child_ages)
								? room.child_ages.map((age) => parseInt(age, 10))
								: []
						}))
					};

					sessionStorage.setItem('formData', JSON.stringify(formData));
				}
			},
			async fetchHotelLocationIfNeeded() {
				if ((this.location && this.location.lat && this.location.lng) || !this.giataId) {
					return;
				}

				const locationUrl = Adzuki.app === 'Web'
					? `${this.baseUri}/HotelSearch/getHotelLocation/${encodeURIComponent(this.giataId)}`
					: `${this.baseUri}/HotelEngine/getHotelLocation/${encodeURIComponent(this.giataId)}`;

				try {
					const response = await fetch(locationUrl);

					if (!response.ok) {
						console.error(`Error fetching hotel location: ${response.statusText}`);
						return;
					}

					const location = await response.json();

					if (!location || !location.lat || !location.lng) {
						return;
					}

					this.location = {
						lat   : location.lat,
						lng   : location.lng,
						radius: location.radius || 25
					};
					this.syncCoordinatesFromLocation();
				} catch (error) {
					console.error('Error fetching hotel location:', error);
				}
			},
		},
		computed: {
			hotelMapPrice() {
				if (!this.hotel?.rooms) {
					return 'Hotel Unavailable';
				}

				let minPrice = null;

				Object.values(this.hotel.rooms).forEach((room) => {
					if (!room.best_value_rates || !Array.isArray(room.best_value_rates)) {
						return;
					}

					room.best_value_rates.forEach((rate) => {
						const price = rate?.pricing?.selling_price;

						if (price && price > 0 && (minPrice === null || price < minPrice)) {
							minPrice = price;
						}
					});
				});

				return (minPrice && minPrice > 0) ? minPrice : 'Hotel Unavailable';
			},
			mapInfo() {
				return [
					{
						lat        : this.hotel.lat,
						lng        : this.hotel.lng,
						title      : this.hotel.name,
						content    : this.hotel.full_address,
						hotel_id   : this.giataId,
						image      : this.hotel.metadata?.images?.[0]?.thumbnail_url || this.baseUri + '/images/map-back.png',
						address    : this.hotel.full_address,
						star_rating: this.hotel.star_rating,
						price      : this.hotelMapPrice,
					}
				];
			},
			numNights() {
				const checkInDate  = new Date(this.criteria.check_in);
				const checkOutDate = new Date(this.criteria.check_out);

				// Ensure check-in date is earlier than check-out date
				if (checkOutDate <= checkInDate) {
					return 0; // No nights if checkout is the same or earlier than check-in
				}

				// Calculate the difference in time (milliseconds)
				const timeDifference = checkOutDate - checkInDate;

				// Convert the time difference to days (1 day = 24 * 60 * 60 * 1000 ms)
				return timeDifference / (1000 * 60 * 60 * 24);

			},
			hotelAmenities() {
				const hotelAmenities = new Set();

				Object.values(this.hotel?.metadata?.amenities || {}).forEach((amenity) => {
					let name = '';

					if (typeof amenity === 'string') {
						name = amenity;
					} else {
						name = amenity?.description || amenity?.mapped_name || '';
					}

					if (name.includes('$$$')) {
						name = name.replaceAll('$$$', '$');
					}

					if (name) {
						hotelAmenities.add(name);
					}
				});

				return Array.from(hotelAmenities);
			},
			roomAmenities() {
				const roomAmenities = new Set();

				if (this.hotel.rooms) {
					Object.values(this.hotel.rooms).forEach((room) => {
						if (room.best_value_rates && Array.isArray(room.best_value_rates)) {
							room.best_value_rates.forEach((rate) => {
								if (rate.provider_data && rate.provider_data.room_amenities) {
									rate.provider_data.room_amenities.forEach((amenity) => {
										roomAmenities.add(amenity); // Add amenity to the set
									});
								}
							});
						}

						if (room.all_rates && Array.isArray(room.all_rates)) {
							room.all_rates.forEach((rate) => {
								if (rate.provider_data && rate.provider_data.room_amenities) {
									rate.provider_data.room_amenities.forEach((amenity) => {
										roomAmenities.add(amenity); // Add amenity to the set
									});
								}
							});
						}
					});
				}

				return Array.from(roomAmenities);
			},
			rateAmenities() {
				const rateAmenities = new Set();

				if (this.hotel.rooms) {
					Object.values(this.hotel.rooms).forEach((room) => {
						if (room.best_value_rates && Array.isArray(room.best_value_rates)) {
							room.best_value_rates.forEach((rate) => {
								if (rate.provider_data && rate.provider_data.rate_amenities) {
									rate.provider_data.rate_amenities.forEach((amenity) => {
										rateAmenities.add(amenity); // Add amenity to the set
									});
								}
							});
						}

						if (room.all_rates && Array.isArray(room.all_rates)) {
							room.all_rates.forEach((rate) => {
								if (rate.provider_data && rate.provider_data.rate_amenities) {
									rate.provider_data.rate_amenities.forEach((amenity) => {
										rateAmenities.add(amenity); // Add amenity to the set
									});
								}
							});
						}
					});
				}

				return Array.from(rateAmenities);
			},
			allAmenities() {
				return Array.from(new Set([...this.hotelAmenities, ...this.roomAmenities, ...this.rateAmenities]));
			},
			hotelSpecialtyRates() {
				// The API sends this as hotel_specialty_rates, an array or keyed object, or not at all.
				const rates = this.hotel?.hotel_specialty_rates ?? this.hotel?.specialty_rates;

				if (Array.isArray(rates)) {
					return rates.filter(Boolean);
				}

				if (rates && typeof rates === 'object') {
					return Object.values(rates).filter(Boolean);
				}

				return [];
			},
			visibleTabs() {
				return this.tabs.filter(tab => {
					if (tab === 'Specialty Rates') {
						return this.hotelSpecialtyRates.length > 0;
					}
					return true;
				});
			},
			totalRoomCount() {
				if (!this.hotel?.rooms || typeof this.hotel.rooms !== 'object') {
					return 0;
				}

				return Object.keys(this.hotel.rooms).length;
			},
			displayedRoomCount() {
				if (this.filteredRooms && typeof this.filteredRooms === 'object') {
					return Object.keys(this.filteredRooms).length;
				}

				return this.totalRoomCount;
			},
			propertyCheckInOut() {
				return this.getPropertyItems([
					'checkin_time_start',
					'checkin_instructions',
					'checkin_special_instructions',
					'checkin_min_age',
					'checkout_time',
				]);
			},
			propertyDescriptions() {
				return this.getPropertyItems([
					'description_amenities',
					'description_dining',
					'description_renovations',
					'description_national_ratings',
					'description_business_amenities',
					'description_rooms',
					'description_attractions',
				]);
			},
			propertyFees() {
				return this.getPropertyItems([
					'fees_mandatory',
					'fees_optional',
				]);
			},
			propertyKnowBeforeYouGo() {
				return this.getPropertyItems([
					'policies_know_before_you_go',
				]);
			},
			mapRadius() {
				const location = this.normalizeLocationPayload(this.location, 25) ||
					this.normalizeLocationPayload(this.coordinates, 25);

				return location ? location.radius : 25;
			},
		},
		async mounted() {
			const container = document.getElementById('hotel-details-container');

			try {
				const parseJsonSafe = (value) => {
					if (!value || typeof value !== 'string') {
						return null;
					}

					try {
						return JSON.parse(value);
					} catch (e) {
						return null;
					}
				};

				const decodeDatasetParam = (value) => {
					if (!value || typeof value !== 'string') {
						return '';
					}

					try {
						return atob(this.decodeUrlParam(value));
					} catch (e) {
						return '';
					}
				};

				const datasetSearchCriteria = parseJsonSafe(
					decodeDatasetParam(
						initialMountData.searchCriteria ||
						this.resolveDatasetValue(container, 'data-search-criteria')
					)
				);
				const datasetSearchLocation = parseJsonSafe(
					decodeDatasetParam(
						initialMountData.selectedLocation ||
						this.resolveDatasetValue(container, 'data-selected-location')
					)
				);
				const datasetRoomFilters = parseJsonSafe(
					decodeDatasetParam(
						initialMountData.roomFilters ||
						this.resolveDatasetValue(container, 'data-room-filters')
					)
				);

				const storedCriteria    = parseJsonSafe(sessionStorage.getItem('searchCriteria'));
				const storedCoordinates = parseJsonSafe(sessionStorage.getItem('coordinates'));
				const storedFormData    = parseJsonSafe(sessionStorage.getItem('formData'));
				const storedLocation    = parseJsonSafe(sessionStorage.getItem('searchLocation'));
				const storedRoomFilters = parseJsonSafe(sessionStorage.getItem('roomFilters'));

				const resolvedHotelId     = this.resolveHotelId(container);
				const resolvedCriteria    = datasetSearchCriteria || storedCriteria;
				const resolvedFormData    = storedFormData;
				const resolvedRoomFilters = datasetRoomFilters || storedRoomFilters;
				const resolvedLocation    = this.normalizeLocationPayload(datasetSearchLocation) ||
					this.normalizeLocationPayload(storedLocation) ||
					this.normalizeLocationPayload(storedCoordinates);

				if (resolvedHotelId) {
					this.giataId = resolvedHotelId;
				}

				if (resolvedCriteria) {
					this.criteria = resolvedCriteria;
				}

				if (resolvedLocation) {
					this.location = resolvedLocation;
					this.syncCoordinatesFromLocation();
				}

				if (resolvedFormData && resolvedFormData.numRooms) {
					this.numRooms = Number(resolvedFormData.numRooms) || 1;
				} else if (resolvedCriteria && Array.isArray(resolvedCriteria.rooms) && resolvedCriteria.rooms.length) {
					this.numRooms = resolvedCriteria.rooms.length;
				}

				if (resolvedRoomFilters && typeof resolvedRoomFilters === 'object') {
					this.roomFilters = resolvedRoomFilters;
				}

				if (container && container.dataset && container.dataset.payLaterActive !== undefined) {
					this.showPayLater = container.dataset.payLaterActive === '1' || container.dataset.payLaterActive === 'true';
				}

				await this.fetchHotelLocationIfNeeded();
				this.persistSearchToSession();

				const flashRaw = sessionStorage.getItem('hotelSearchFlash');

				if (flashRaw) {
					sessionStorage.removeItem('hotelSearchFlash');

					try {
						const flash = JSON.parse(flashRaw);

						if (flash?.message) {
							this.openAlert(
								flash.type || 'error',
								flash.title || 'Notice',
								flash.message
							);
						}
					} catch (flashError) {
						console.error('Unable to show hotel search flash:', flashError);
					}
				}
			} catch (error) {
				console.error('Error parsing local storage data:', error);
			}

			this.fetchHotelDetails();
			this.fetchScopes();
		},
		provide() {
			return {
				openAlert              : this.openAlert,
				openToast              : this.openToast,
				selectRoom             : this.selectRoom,
				$inject_availableScopes: Vue.computed(() => this.availableScopes),
			};
		},
	};

	$(document).ready(function documentReady() {
		const vueContainer = document.getElementById('hotel-details-container');

		if (vueContainer) {
			initialMountData = {
				hotelId         : vueContainer.getAttribute('data-hotel-id') || vueContainer.dataset?.hotelId || '',
				searchCriteria  : vueContainer.getAttribute('data-search-criteria') || vueContainer.dataset?.searchCriteria || '',
				selectedLocation: vueContainer.getAttribute('data-selected-location') || vueContainer.dataset?.selectedLocation || '',
				roomFilters     : vueContainer.getAttribute('data-room-filters') || vueContainer.dataset?.roomFilters || '',
			};

			// initialize app and register components
			const app = Vue.createApp(appConfig);

			const loggedInRef = Vue.ref(Boolean(vueContainer.dataset.loggedIn));

			// Provide it to all child components
			app.provide('$inject_loggedIn', loggedInRef);
			app.provide('setLoggedIn', (val) => {
				loggedInRef.value = val;
			});

			// Add components
			app.component('adzuki-alert', Adzuki.VueComponents.AdzukiAlert);
			app.component('adzuki-toast', Adzuki.VueComponents.AdzukiToast);
			app.component('adzuki-loading', Adzuki.VueComponents.AdzukiLoading);
			app.component('adzuki-google-map', Adzuki.VueComponents.AdzukiGoogleMap);
			app.component('adzuki-mytrips-login', Adzuki.VueComponents.AdzukiMyTripsLogin);
			app.component('adzuki-carousel', Adzuki.VueComponents.AdzukiCarousel);
			app.component('adzuki-modal', Adzuki.VueComponents.AdzukiModal);
			app.component('he-room-filter', Adzuki.VueComponents.HotelEngineRoomFilter);
			app.component('he-room', Adzuki.VueComponents.HotelEngineRoom);
			app.component('he-rates', Adzuki.VueComponents.HotelEngineRates);
			app.component('he-rate-badge', Adzuki.VueComponents.HotelEngineRateBadge);
			app.component('he-rate-details', Adzuki.VueComponents.HotelEngineRateDetails);
			app.component('he-specialty-rates', Adzuki.VueComponents.HotelEngineSpecialtyRates);
			app.component('he-reviews', Adzuki.VueComponents.HotelEngineReviews);
			app.component('he-room-modal-content', Adzuki.VueComponents.HotelEngineRoomModalContent);

			app.config.globalProperties.$baseUri = Adzuki.base_uri;

			// Add directives
			app.directive('formatDate', Adzuki.VueDirectives.FormatDate);
			app.directive('formatCurrency', Adzuki.VueDirectives.FormatCurrency);

			app.mount('#hotel-details-container');
		}
	});


}(jQuery, window.Adzuki || {}));